import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { APP_NAME, APP_TAGLINE, TID } from "@/lib/constants";

export default function Splash({ onDone }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setShow(false);
      setTimeout(() => onDone && onDone(), 220);
    }, 1400);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid={TID.splashRoot}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.22 }}
          className="fixed inset-0 z-[60] min-h-screen bg-[#111622] flex items-center justify-center"
        >
          <div className="flex flex-col items-center text-center px-6">
            <motion.div
              className="w-[180px] h-[180px] select-none"
              initial={{ scale: 0.92, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.42, ease: [0.2, 0.8, 0.2, 1] }}
            >
              <picture>
                <source srcSet="/brand/distill-mark.webp" type="image/webp" />
                <img
                  src="/brand/distill-mark.png"
                  srcSet="/brand/distill-mark.png 1x, /brand/distill-mark@2x.png 2x"
                  alt=""
                  width={180}
                  height={180}
                  draggable="false"
                  loading="eager"
                  fetchpriority="high"
                  decoding="async"
                  className="w-full h-full object-contain"
                />
              </picture>
            </motion.div>
            <motion.div
              initial={{ y: 8, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.18, duration: 0.32, ease: [0.2, 0.8, 0.2, 1] }}
              className="mt-6"
            >
              <span
                data-testid={TID.splashTitle}
                className="block text-xl font-semibold tracking-[0.34em] text-[#F8FAFC]"
              >
                {APP_NAME}
              </span>
              <p
                data-testid={TID.splashTagline}
                className="mt-3 text-[11px] font-semibold uppercase tracking-[0.24em] text-[#E85A2A]"
                style={{ lineHeight: 1.6 }}
              >
                {APP_TAGLINE}
              </p>
              <p className="mt-2 text-xs text-[#94A3B8]" style={{ lineHeight: 1.6 }}>
                Distilling today’s high-yield cards…
              </p>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
